import axios from "@/lib/axios";

export type ExportQuizWithAnswersRequestParams = {
  companyId: string;
  quizId: string;
};

export type ExportQuizWithAnswersResponse = Blob;

export const exportQuizWithAnswers = (
  params: ExportQuizWithAnswersRequestParams,
) =>
  axios.get<ExportQuizWithAnswersResponse>(
    `/v1/companies/${params.companyId}/application-quizzes/${params.quizId}/export`,
    { responseType: "blob" },
  );
